export interface CompanyProfileDTO {
    id: string;
    companyDescription: string | null;
    companyName: string;
    companyUrl: string;
    companySlug: string;
    companyLogoURL: string | null;
    companyIconURL: string | null;
}

export const DefaultCompanyProfileDTO: CompanyProfileDTO = {
    id: '',
    companyName: '',
    companyDescription: null,
    companyUrl: '',
    companySlug: '',
    companyLogoURL: null,
    companyIconURL: null,
};
